<template>
  <ul class="lang-select" :style="ulMargin">
    <div class="header-wrapper" @click="handlerArrow">
      <img v-if="headerImg" :style="imgStyle" :src="headerImg" alt="header img" />
      <div class="header">{{ currentSelect }}</div>
      <img
        src="~img/menuArrowUp@2x.png"
        alt="menu expand"
        :class="['arrow', { 'arrow-down': arrowDown }]"
      />
    </div>
    <li
      v-for="(item, index) in listData"
      :key="index"
      @click="listItemClick(item)"
      :class="['list-item', { 'list-item-select': item.select, 'arrow-down': arrowDown }]"
      :style="liItemImgStyle"
    >
      <img v-if="item.itemImg" :style="itemImgStyle" :src="item.itemImg" alt="header img" />
      <span><slot name="itemDesc" :item="item"></slot></span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        arrowDown: true,
      };
    },
    props: {
      currentSelect: {
        default: 'ENG',
        type: String,
      },
      listData: {
        default: () => [],
        type: Array,
      },
      targetSelected: {
        default: 0,
        type: Number,
      },
      headerImg: {},
      itemImg: {},
      imgStyle: {
        default: () => {},
        type: Object,
      },
      itemImgStyle: {
        default: () => {},
        type: Object,
      },
      liItemImgStyle: {
        default: () => {},
        type: Object,
      },
      ulMargin: {
        default: () => {},
        type: Object,
      },
    },
    methods: {
      handlerArrow() {
        this.arrowDown = !this.arrowDown;
      },
      listItemClick(item) {
        this.$emit('listItemClick', item);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'index';
</style>
